import {TriggerAttachmentType} from 'src/openapi/models/TriggerAttachmentType';

export const getTriggerAttachmentType = (type: string) => {
    return type.startsWith('video/') ? TriggerAttachmentType.VIDEO : TriggerAttachmentType.IMAGE;
};
